export default __webpack_public_path__ + "static/media/02AW1JUL66.5cfc74bf.jpg";